var React = require('react');

function ControlInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m18.1039953 6.50603122c-.7205164-7.01679675 2.4685418-6.36499804 4.463252-6.49965944 1.0964253-.07401885 4.6620178.52127869 5.0480797.52127869.953666 0 1.7819378 5.04843703 1.1807188 7.49821347-.601219 2.44977646-3.1333629.73199413-4.6954786 1.77333678-.5856821.39042928-2.0389943.11056555-2.615915 0-1.9585565-.37535288-3.0854421-1.47307604-3.3806569-3.2931695z","fill":"none","opacity":".444","stroke":"#fbc5a9","strokeWidth":"2","transform":"translate(-17 1)"}));
}

ControlInline.defaultProps = {"height":"12","viewBox":"0 0 13 12","width":"13"};

module.exports = ControlInline;

ControlInline.default = ControlInline;
